import loader from '../../../assets/loader.svg';

const Margin = ({ margin, isLoading }: { margin: number; isLoading: boolean }) => {
  return (
    <div style={styles.container}>
      <div style={styles.textContainer}>
        <div style={styles.title}>Margin</div>
        {isLoading ? (
          <img src={loader} className="rotating" alt="logout" style={{ width: '1.9vh', height: '1.9vh' }} />
        ) : (
          <div style={styles.discount}>{margin}%</div>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  textContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row' as 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '0.4vh',
  },
  title: {
    fontSize: '1.4vh',
    fontWeight: '700',
    color: '#101D3B',
    textAlign: 'left' as 'left',
  },
  discount: {
    fontSize: '1.4vh',
    fontWeight: '700',
    color: '#00AB9B',
  },
};

export default Margin;
